import React from 'react';
import { useSystemStatus } from '../context/SystemStatusContext';

const SystemDownOverlay = () => {
  const { isDown, checking, retry } = useSystemStatus();

  if (!isDown) {
    return null;
  }

  return (
    <div
      className="system-down-overlay fixed inset-0 z-[200] flex items-center justify-center px-4"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="system-down-title"
      aria-describedby="system-down-message"
    >
      <div className="system-down-orb system-down-orb-left" aria-hidden="true" />
      <div className="system-down-orb system-down-orb-right" aria-hidden="true" />

      <div className="relative w-full max-w-lg">
        <div className="rounded-3xl border border-white/10 bg-white/95 shadow-2xl backdrop-blur-xl overflow-hidden">
          <div className="h-1.5 w-full bg-gradient-to-r from-primary-500 via-accent-400 to-primary-600" />

          <div className="px-8 pt-10 pb-8 text-center">
            <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-50 shadow-inner">
              <span className="relative flex h-4 w-4">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
                <span className="relative inline-flex h-4 w-4 rounded-full bg-primary-600" />
              </span>
            </div>

            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              Liaizn
            </p>
            <h1
              id="system-down-title"
              className="text-2xl md:text-3xl font-bold text-secondary-900 leading-tight"
            >
              The system is currently unavailable
            </h1>
            <p
              id="system-down-message"
              className="mt-4 text-base text-secondary-600 leading-relaxed"
            >
              Backend services are temporarily down. Please contact your administrator
              for assistance. You can try again once the platform has been restarted.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <button
                type="button"
                onClick={retry}
                disabled={checking}
                className="btn-primary inline-flex items-center justify-center px-6 py-3 disabled:opacity-70 disabled:cursor-wait"
              >
                {checking ? (
                  <>
                    <svg
                      className="mr-2 h-4 w-4 animate-spin"
                      viewBox="0 0 24 24"
                      fill="none"
                      aria-hidden="true"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                    Checking services…
                  </>
                ) : (
                  'Try again'
                )}
              </button>
            </div>

            <p className="mt-6 text-sm text-secondary-500">
              Contact admin if this continues.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemDownOverlay;
